export const add_todo = 'ADD TODO';
export const set_todo = 'SET TODO';
export const complete_todo = 'COMPLETE TODO';
export const clear_completed = 'CLEAR COMPLETED';
export const filter_all = 'FILTER ALL';
export const filter_active = 'FILTER ACTIVE';
export const filter_completed = 'FILTER COMPLETED';
export const update_list_order = 'UPDATE LIST ORDER';
export const set_user_id = 'SET USER ID';
